<template>
  <a-config-provider :locale="zh_CN">
    <div id="app">
      <!-- 悬浮球 -->
      <template v-if="$route.name === 'Suspension' && isElectron">
        <router-view />
      </template>
      <!-- 应用窗口 -->
      <template v-else-if="$route.name !== 'Suspension'">
        <MyTitle v-if="!isShowTitle" />
        <keep-alive>
          <router-view
            v-if="$route.meta.keepAlive"
            :class="['container', $route.name === 'Home' ? 'home' : '']"
            :style="{ fontSize: size + 'px' }"
          />
        </keep-alive>
        <router-view
          v-if="!$route.meta.keepAlive"
          :class="['container', $route.name === 'Home' ? 'home' : '']"
          :style="{ fontSize: size + 'px' }"
        />
        <import-resource ref="importResource" />
        <function-menu ref="functionMenu" v-move @openBindModal="openBindModal" />
        <bind-d-t-q-modal ref="BindDTQModalRef" />
        <GlobalTimer v-if="globalTimerVisible" ref="globalTimerRef" />
      </template>
    </div>
  </a-config-provider>
</template>
<script>
// import { token } from '@/utils/mockData'

import FunctionMenu from '@/components/common/FunctionMenu'
import BindDTQModal from './components/common/BindDTQModal.vue'
import ImportResource from '@/components/common/ImportResource.vue'
import throttleV2 from '@/utils/throttleV2'
import { initDTQ, setDTQBindTeacherData } from '@/utils/dtq'
import { isRunningInElectron } from '@/utils/electronUtils'
import zh_CN from 'ant-design-vue/lib/locale-provider/zh_CN'
import GlobalTimer from '@/components/globalTimer/globalTimer.vue'

export default {
  name: 'App',
  components: {
    GlobalTimer,
    FunctionMenu,
    ImportResource,
    BindDTQModal
  },
  directives: {
    move(el, binging, vnode) {
      const that = vnode.context
      el.onmousedown = function (e) {
        let timer = setTimeout(() => {
          // 获取鼠标点击处分别与div左边和div上边的距离：鼠标位置-div位置
          const startX = e.clientX - el.offsetLeft
          const startY = e.clientY - el.offsetTop
          el.style.cursor = 'move'
          throttleV2(
            (document.onmousemove = function (ev) {
              const event = ev || window.event
              const moveX = event.clientX - startX
              const moveY = event.clientY - startY
              el.style.left = moveX + 'px'
              el.style.top = moveY + 'px'
              that.$refs.functionMenu.isMoving = true
            }),
            500
          )
        }, 500)

        const startX = e.clientX - el.offsetLeft
        const startY = e.clientY - el.offsetTop
        throttleV2(
          (document.onmousemove = function (ev) {
            const event = ev || window.event
            const moveX = event.clientX - startX
            const moveY = event.clientY - startY
            if (Math.abs(moveX) > 50 || Math.abs(moveY) > 50) {
              clearTimeout(timer)
              timer = null
            }
          }),
          300
        )

        // 鼠标弹起时不再移动
        el.onmouseup = function (e) {
          clearTimeout(timer)
          timer = null
          document.onmousemove = null
          setTimeout(() => {
            that.$refs.functionMenu.isMoving = false
          }, 50)
          el.style.cursor = ''
        }
      }
    }
  },
  data() {
    return {
      zh_CN,
      isElectron: false,
      isShowTitle: false, // 是否隐藏标题
      globalTimerVisible: false
    }
  },
  computed: {
    size() {
      return Number(this.$store.getters.size)
    }
  },
  watch: {
    $route(to) {
      this.isShowTitle = to?.meta?.isShowTitle
    }
  },
  created() {
    this.isElectron = isRunningInElectron()
    if (this.isElectron) {
      initDTQ()
    }
    this.$store.commit('app/SET_IN_ELECTRON', this.isElectron)
    this.$bus.$on('dtqMessage', async data => {
      if (data.fun === 'card_update' && data.uID_t === 50) {
        await setDTQBindTeacherData(data)
        await initDTQ()
      }
    })
    this.$bus.$on('pointerMessage', data => {
      switch (data.ans_str) {
        case 'E':
          window.electron.ipcRenderer.send('window-show')
          break
        case 'F':
          window.electron.ipcRenderer.send('window-min')
          break
        case 'A':
        case 'B':
          if (data.key_event === 'double') {
            this.$router.back()
          }
          break
      }
    })
    this.$bus.$on('showGlobalTimer', minutes => {
      this.globalTimerVisible = true
      this.$nextTick(() => {
        this.$refs.globalTimerRef.time = minutes * 60
        this.$refs.globalTimerRef.totalTime = minutes * 60
      })
    })
    this.$bus.$on('hideGlobalTimer', () => {
      this.globalTimerVisible = false
    })
    this.$bus.$on('showGlobalTimerCustomModal', () => {
      this.globalTimerVisible = true
      this.$nextTick(() => {
        this.$refs.globalTimerRef.handleClickCustom()
      })
    })
  },
  methods: {
    openBindModal() {
      this.$refs.BindDTQModalRef.openModal()
    }
  }
}
</script>

<style lang="scss">
// 点名淡入淡出
.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.5s cubic-bezier(0.8, -0.48, 1, 1);
}

.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateZ(10px) translateY(30px);
  opacity: 0;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  border: 1px solid transparent;
  box-sizing: border-box;
  width: 100vw;
  height: 100vh;
  touch-action: none;
}

html,
body,
div {
  margin: 0;
  padding: 0;
}

.container {
  width: 100%;
  // 头部40 底部64
  height: calc(100vh - 106px);
  position: relative;
  overflow: auto;
  &.home {
    // 头部40
    height: calc(100vh - 42px);
  }

  .footer {
    position: fixed;
    bottom: 1px;
    left: 1px;
    z-index: 99;
  }
}
// 滚动条整体粗细样式
::-webkit-scrollbar {
  // 高宽分别对应横竖滚动条的尺寸
  width: 16px;
  height: 16px;
}

// 滚动条里面滑块
::-webkit-scrollbar-thumb {
  border-radius: 8px !important;
  // 通过设置边框达到滑块在轨道中间的效果
  border: 3px solid #ffffff;
  /* 颜色 */
  background: #e5e5e5 !important;
}

// 滚动条轨道
::-webkit-scrollbar-track {
  background: transparent !important;
}

/* 标签样式 */
xmp {
  white-space: normal;
  margin: 0;
}

blockquote {
  display: block;
  text-indent: 2em;
  margin: 0;
}

b {
  font-weight: bold;
}

c {
  display: block;
  text-align: center;
}

l {
  display: block;
  text-align: left;
}

r {
  display: block;
  text-align: right;
}

u {
  text-decoration: underline;
}

u2 {
  border-bottom: 2px double black;
}
.t-content {
  t {
    background-color: #fc683a;
    height: 21px;
    line-height: 21px;
    padding: 0 20px;
    border-radius: 4px;
    color: #fff;
    text-align: center;
    white-space: nowrap;
    cursor: pointer;
  }

  .active {
    background-color: #fff;
    border: 1px solid #c8c8c8;
    color: #ff7c53;
  }

  .answer-text {
    display: inline-block;
    background: #ffffff;
    height: 21px;
    padding: 0 15px;
    border: 1px solid #1dc060;
    border-radius: 4px;
    text-align: center;
    color: #1dc060;
    font-size: 12px;
    white-space: nowrap;
  }

  .false {
    background-color: #fff;
    color: #ff3c30;
    border: 1px solid #ff3c30;
  }

  .noAnswer {
    background-color: #fff;
    color: #309af2;
    border: 1px solid #309af2;
  }
}
.none {
  display: none;
}

.bg-f6 {
  background-color: #f6f6f6;
}

.text-center {
  text-align: center;
}

.text-right {
  text-align: right;
}

.col-999 {
  color: #999 !important;
}

.col-1DC060 {
  color: #1dc060 !important;
}

.bg-col-1DC060 {
  background: #1dc060;
}

.bg-col-1DC060-gradient {
  background: linear-gradient(270deg, #41ea86 0%, #1dc060 100%);
}

.col-FFA516 {
  color: #ffa516 !important;
}

.bg-col-FFA516 {
  background: #ffa516;
}

.bg-col-FFA516-gradient {
  background: linear-gradient(270deg, #ffd131 0%, #ffa516 100%);
}

.col-FF3C30 {
  color: #ff3c30 !important;
}

.bg-col-FF3C30 {
  background: #ff3c30;
}

.bg-col-FF3C30-gradient {
  background: linear-gradient(90deg, #ff3c30 0%, #ff7b72 100%);
}

.col-1976FF {
  color: #1976ff !important;
}

.pre-line {
  white-space: pre-line;
}

.pointer {
  cursor: pointer;
}

.hidden {
  visibility: hidden;
}

.repeat-txt {
  display: inline-block;
  background-color: #ff9756;
  color: #ff9756;
}

.repeat-txt::selection {
  color: transparent;
}
.fullscreen-modal {
  top: 41px !important;
}
</style>
